import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/final-circuit/$circuitId/notifications/',
)({
    component: RouteComponent,
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/customer/locations/$locationId/electrical/projects/$projectId/final-circuit/$circuitId', params });
    },
});

function RouteComponent() {
    return null;
}
